import React, { useEffect, useState } from "react";
import config from "../../config/config";
import Header from "../../directives/header";
import { Zoom, Fade, Slide, Roll } from "react-reveal";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import NewHeader from "../../directives/NewHeader";
import {
  Accordion,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from "react-bootstrap";
import { getFaqsAction } from "../../Action/user.action";

const Faq = () => {
   const [activeKey, setActiveKey] = useState("0");
   const [faqs, setFaqsList] = useState([])
 
   const toggleKey = (key) => {
     setActiveKey(activeKey === key ? null : key);
   };
 

  useEffect(() => {
    getFaqs();
  }, [])

  const getFaqs = async () => {
    let res = await getFaqsAction();
    if (res.success) {
      setFaqsList(res.data);
    } else {
      setFaqsList([]);
    }
  }

  return (
    <>
      <div className="position-fixed w-100" style={{ zIndex: 999 }}>
        <NewHeader />
      </div>

      <section className="position-relative overflow-hidden">
        <div className="leftshadow">
          <img src="assets/images/blueleft.png" />

        </div>
        <Container>
         
         
          <Col lg={12} className="mt-5">
            <Zoom>
              <div className="questions">
                <Accordion activeKey={activeKey}>
                  {faqs.map((item, index) => (
                    <Card
                      key={index}
                      className="faq-card bg-dark text-white mb-2"
                    >
                      <Accordion.Item
                        className="new-contact-us-item"
                        eventKey={index.toString()}
                      >
                        <Accordion.Header
                          onClick={() => toggleKey(index.toString())}
                        >
                         
                          <h5 className="text-gradient mb-0">{index + 1}. {item.question} </h5>
                        </Accordion.Header>
                        <Accordion.Body>
                    <p className="text-light-grey">{item.answer}</p>
                  </Accordion.Body>
                      </Accordion.Item>
                    </Card>
                  ))}
                </Accordion>
              </div>
            </Zoom>
          </Col>
        </Container>
      </section>

    </>
  );
};
export default Faq;
